'use client';

import clsx from 'clsx';
import { Button } from '@publishing/components/ui/Button';
import { resolveConfig } from './_config';
import BlogLatest from './BlogLatest';
import type { BlogArticle } from './_types';
import styles from './SubmitResult.module.scss';

export interface SubmitResultProps {
  type: 'popup' | 'page' | 'inline';
  headingLevel?: 1 | 2;
  configKey?: string;
  articles?: BlogArticle[];
  onClose?: () => void;
  className?: string;
}

export default function SubmitResult({
  type,
  headingLevel,
  configKey = 'default',
  articles = [],
  onClose,
  className,
}: SubmitResultProps) {
  const resolved = resolveConfig(configKey);
  const title = resolved?.title ?? '';
  const description = resolved?.description ?? '';

  const showButton = type === 'popup' || type === 'page';
  const HeadingTag = (headingLevel ?? (type === 'page' ? 1 : 2)) === 1 ? 'h1' : 'h2';

  return (
    <div className={clsx(styles.root, styles[`root_${type}`], className)}>
      <div className={styles.message_area}>
        <HeadingTag className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
        <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className={styles.content_area}>
        {articles.length > 0 && (
          <div className={styles.articles}>
            <BlogLatest
              articles={articles}
              compact={type === 'popup'}
              showKeywords={type === 'popup' || type === 'page'}
            />
          </div>
        )}
        {showButton && (
          <div className={styles.actions}>
            <Button
              href={type === 'popup' ? undefined : '/'}
              onClick={type === 'popup' ? onClose : undefined}
              type="black"
              size="large"
              className={styles.action_btn}
              icon={false}
            >
              {type === 'popup' ? '닫기' : '홈으로'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
